import api from '@/api/url'
import type { NoticeListItem, NoticeListResponse } from './model/noticeType'
import { jwtClientAxios } from '.'

export const getNoticeListApi = async (): Promise<NoticeListResponse> => {
  try {
    const response = await jwtClientAxios().get(api.notice.NOTICE_LIST)
    return response.data.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const getNoticeDetailApi = async (noticeId: number): Promise<NoticeListItem> => {
  try {
    const response = await jwtClientAxios().get(api.notice.NOTICE_DETAIL(noticeId))
    return response.data.data
  } catch (error) {
    console.error(error)
    throw error
  }
}

export const markAsReadAllNoticeApi = async (): Promise<any> => {
  try {
    const response = await jwtClientAxios().post(api.notice.NOTICE_READ_ALL)
    return response.data
  } catch (error) {
    console.error(error)
    throw error
  }
}
